// import EmptyGuard from "@/components/global/Empty"
import Loading from "@/components/global/Loading";
import ProductCard from "@/components/global/ProductCard";
import RightArrowIcon from "@/components/icons/rightArrowIcon";
import { getProductsBySkus } from "@/services/product";
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";

export default function Accessories({ accessories }) {
  const { handshake } = getCookies();
  const [activeAccessoryCategory, setActiveAccessoryCategory] = useState(
    accessories?.at(0)
  );
  const [catProducts, setCatProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getProductsBySkus(
      handshake,
      activeAccessoryCategory?.accessory_products.map((ac) => ac.sku)
    ).then((res) => {
      if (res.status == 200) {
        setCatProducts(res?.data?.data?.products);
      }
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeAccessoryCategory]);
  return (
    <section className="max-sm:bg-[#F8F7F7] max-sm:p-3">
      <div className="flex sm:gap-4 max-sm:flex-col max-sm:bg-white">
        <div className="max-sm:w-full sm:min-w-48 sm:bg-[#F8F7F7] sm:rounded-lg h-fit">
          {accessories?.map((acc, i) => (
            <div
              onClick={() =>
                setActiveAccessoryCategory(
                  accessories?.find(
                    (item) => item.accessory_name == acc.accessory_name
                  )
                )
              }
              key={i}
              className={`flex gap-3 items-center max-sm:justify-between max-sm:flex-row-reverse ${
                activeAccessoryCategory?.accessory_name == acc?.accessory_name
                  ? "sm:text-[#4861A7]"
                  : "hover:bg-gray-200"
              } hover:cursor-pointer p-2`}
            >
              <RightArrowIcon className="text-black size-3" />
              <p
                className={`${
                  activeAccessoryCategory?.accessory_name == acc?.accessory_name
                    ? "font-bold"
                    : "font-normal"
                } text-sm sm:text-lg`}
              >
                {acc?.accessory_name}
              </p>
            </div>
          ))}
        </div>
        {!loading ? (
          <div className="grid max-sm:flex max-sm:overflow-x-auto max-sm:*:min-w-40 max-sm:*:max-w-min-w-40 grid-cols-2 gap-1 sm:gap-4 md:grid-cols-3 lg:grid-cols-4 max-sm:p-1.5">
            {catProducts?.map((pr, key) => (
              <ProductCard key={key} product={pr} />
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center flex-1 h-44">
            <Loading />
          </div>
        )}
      </div>
    </section>
  );
}
